import { createRoot } from 'react-dom/client';
import '@/i18n';
import '@/ui/styles.css';
import { LaunchSplash } from '@/app/App';
import { mountApplication } from '@/app/bootstrap';
import { i18next } from '@/i18n';

const root = document.getElementById('root');
if (!root) throw new Error('#root missing');
// A feature error can contain private response data; React must not print caught exceptions.
const application = createRoot(root, { onCaughtError: () => undefined, onRecoverableError: () => undefined });
application.render(<LaunchSplash />);
try { mountApplication(application); }
catch {
  application.render(<main className="shell-splash" role="alert"><p>{i18next.t('shell:bootError')}</p><button className="shell-primary" onClick={() => window.location.reload()}>{i18next.t('shell:reload')}</button></main>);
}
